import { render } from "./FormBoxDivider.vue?vue&type=template&id=1bf6c410"
import script from "./FormBoxDivider.vue?vue&type=script&lang=js"
export * from "./FormBoxDivider.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./FormBoxDivider.vue?vue&type=style&index=0&id=1bf6c410&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script